import { Button, Grid, TextField, Paper, Typography, Box, CircularProgress } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { useAppDispatch, useAppSelector } from '@redux/stores/hooks';
import { fetchHelpAction, updateHelpAction } from '@redux/actions/help';
import { RootState } from '@redux/stores/store';
import { useNavigate } from "react-router-dom";
import { ROUTES } from '@components/consts';
import SaveIcon from '@mui/icons-material/Save';
import { Editor } from '@tinymce/tinymce-react';
import { getEditorConfiguration } from './config';

export default function UpdateHelp() {
  const editorRef = useRef(null);
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const { list, loading } = useAppSelector((state: RootState) => state.help);

  const apiKey = '90kxvcu9vgdw5stdn7ndmzm68xj2winmkdaklxxygc0js73y';

  const help = list.find(
    (t) => t._id === id,
  );
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [order, setOrder] = useState(0);
  const [content, setContent] = useState('');

  useEffect(() => {
    dispatch(fetchHelpAction(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (help?.title) {
      setTitle(help.title);
    }
    if (help?.order) {
      setOrder(help.order);
    }
    if (help?.content) {
      setContent(help.content);
    }
  }, [help]);

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleOrderChange = (event) => {
    setOrder(event.target.value);
  };

  const handleEditorChange = (content: string) => {
    setContent(content);
  };

  return (
    <Grid sx={{
      width: '100%',
      padding: '10px',
      '& hr': {
        margin: '10px auto',
      },
    }} container spacing={1}>
      <Grid item xs={12}>
        {loading ?
          (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress size={70} />
            </Box>
          ) : (
            <Paper sx={{
              padding: '10px',
              display: 'flex',
              overflow: 'auto',
              flexDirection: 'column',
            }}>
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                sx={{
                  flexGrow: 1,
                  marginBottom: '10px',
                }}
              >
                Edytuj element
              </Typography>
              <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={9}>
                  <TextField
                    label="Tytuł"
                    value={title}
                    onChange={handleTitleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label="Priorytet"
                    value={order}
                    type='number'
                    onChange={handleOrderChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Editor
                onInit={(_evt, editor) => (editorRef.current = editor)}
                apiKey={apiKey}
                value={content}
                init={getEditorConfiguration(editorRef)}
                onEditorChange={handleEditorChange}
              />
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={() => {
                  console.log(content)
                  dispatch(
                    updateHelpAction({ ...help, title, order, content }),
                  );

                  navigate(ROUTES.helpManage.href);
                }}
                startIcon={<SaveIcon />}
              >
                Zapisz
              </Button>
            </Paper>
          )}
      </Grid>
    </Grid>
  );
}